export default {
  wages: {
    default: 8000,
    min: 0,
    max: 9999999,
    error: 'Wages need to be between 0 and 9,999,999'
  },
  investments: {
    default: 0,
    min: 0,
    max: 99999999,
    error: 'Investments need to be between 0 and 9,999,999'
  },
  alimonyIncome: {
    default: 0,
    min: 0,
    max: 99999999,
    error: 'Alimony income needs to be between 0 and 9,999,999'
  },
  otherIncome: {
    default: 0,
    min: 0,
    max: 99999999,
    error: 'Other income needs to be between 0 and 9,999,999'
  },
  downPayment: {
    default: 20000,
    min: 1,
    max: 99999999,
    error: 'Down payment needs to be between 1 and 9,999,999'
  },
  loanTerm: {
    default: 30,
    min: 1,
    max: 99,
    error: 'Loan term needs to be between 1 and 99'
  },
  interestRate: {
    default: 4.5,
    min: 0,
    max: 10,
    error: 'Interest rate needs to be between 0 and 10'
  },
  homeownerInsurance: {
    default: 1900,
    min: 0,
    max: 99999999,
    error: 'Homeowner insurance needs to be between 0 and 9,999,999'
  },
  realEstateTaxes: {
    default: 2500,
    min: 0,
    max: 99999999,
    error: 'Real estate taxes need to be between 0 and 9,999,999'
  },
  carPayment: {
    default: 0,
    min: 0,
    max: 99999999,
    error: 'Car payment needs to be between 0 and 9,999,999'
  },
  alimonyPaid: {
    default: 0,
    min: 0,
    max: 99999999,
    error: 'Alimony paid needs to be between 0 and 9,999,999'
  },
  creditCardPayment: {
    default: 1600,
    min: 0,
    max: 99999999,
    error: 'Credit card payment needs to be between 0 and 9,999,999'
  },
  otherDebtPayment: {
    default: 0,
    min: 0,
    max: 99999999,
    error: 'Other debts need to be between 0 and 9,999,999'
  }
}
